module.exports = __webpack_public_path__ + "img/봉은사역 카페.87051238.png";